import React from 'react';
import { LiveResults as CurrentResults } from './LiveRule.jsx';

export default function ProcessingLedger({ children = null }) {
  return <>
    <header className="page-header"><div>
      <div className="eyebrow">PROCESSING</div><h1>Decomposition results</h1>
    </div></header>
    <section className="gap-notice" role="status">
      <strong>The historical 100-source processing panel is retired.</strong>
      <p>Its observations came from a retired engine and cannot establish current decomposition success.
        Original legislative sources are preserved separately.</p>
      <p>Selected-runtime processing and decomposition results remain available below.</p>
    </section>
    {children ?? <CurrentResults />}
  </>;
}
